import type { WaterfallSeriesModel } from './type';
import { TYPE, TWO_STACKED_COLUMN_CHARTS, THREE_DATA_ITEMS } from './util';

/**
 * 判断是否是瀑布图的 Model 实例
 */
export function isWaterfallSeries(seriesModel: WaterfallSeriesModel) {
  return (
    // 基于堆叠柱状图实现
    seriesModel.get('type') === 'bar' &&
    typeof seriesModel.get('stack') !== 'undefined' &&
    // 特殊标记
    seriesModel.get('dvType') === TYPE
  );
}

export function filterWaterfallSeries(seriesModels: WaterfallSeriesModel[]) {
  return seriesModels.filter(seriesModel => isWaterfallSeries(seriesModel));
}

/**
 * 遍历多个瀑布图，一个瀑布图 = 一个堆叠柱状图 = 多个柱状图
 *
 * !- 瀑布图的实现基于堆叠柱状图，当前实现不考虑多列堆叠的情况
 */
export function eachWaterfall(
  seriesModels: WaterfallSeriesModel[],
  cb: (seriesModels_: WaterfallSeriesModel[]) => void
) {
  const map = new Map<string, WaterfallSeriesModel[]>();

  seriesModels.forEach(seriesModel => {
    const key = [
      seriesModel.get('xAxisIndex'),
      seriesModel.get('yAxisIndex'),
      seriesModel.get('polarIndex'),
      seriesModel.get('stack')
    ].join('-');

    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key).push(seriesModel);
  });

  Array.from(map.values())
    .filter(
      seriesModels_ =>
        seriesModels_.length >= TWO_STACKED_COLUMN_CHARTS &&
        seriesModels_.every(seriesModel => seriesModel?.getData()?.count?.() >= THREE_DATA_ITEMS)
    )
    // ! 暂不考虑多列堆叠
    .slice(0, 1)
    .forEach(seriesModels_ => {
      // ! 去掉第一个是因为利用堆叠柱状图实现瀑布图时，第一个柱状图只是用来撑高从第二个开始的柱状图
      cb(seriesModels_.slice(1));
    });
}
